export const hasSearchQuery = (state) => state.searchQuery !== '';
